<script>
import Layout from "../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { filter } from "../../helpers/Vue-Filter";
import add from "./add.vue";
import edit from "./edit.vue";
import startVideo from "./start-video.vue";
import Swal from "sweetalert2";
import Loader from "../../components/widgets/loader.vue";
import api from "@/api";
import moment from "moment";
import Pagination from "../../components/widgets/pagination.vue";

export default {
  /* eslint-disable no-console */

  filters: {
    ...filter,
  },

  page: {
    title: "関節モーニング動画",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: { startVideo, add, Layout, PageHeader, Loader, edit, Pagination },

  data() {
    return {
      breadcrumb: [
        {
          text: "関節モーニング動画",
          href: "/admin/videos",
          active: true,
        },
      ],
      items: [],
      pagination: {
        current_page: 1,
        total: 20,
        per_page: 20,
      },
      loader: false,
      page: 1,
      latestPage: 5,
      video: "https://s3.pstatp.com/aweme/resource/web/static/image/index/tvc-v2_30097df.mp4",
      isFlagShowModalAdd: false,
      isFlagShowModalEdit: false,
      urlVideo: null,
      showVideoFlag: false,
      editingItem: {},
      lastLoadedTime: null,
    };
  },

  async created() {
    await this.getVideos();
    const formattedDate = moment().format('YYYY/MM/DD HH:mm:ss');
    localStorage.setItem('lastLoadedTime', formattedDate);
    this.lastLoadedTime = localStorage.getItem('lastLoadedTime');
  },

  computed: {
    theme() {
      return this.$store.state.theme;
    },
    
    columns() {
      return [
        {
          key: "thumbnail",
          label: "",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "type",
          label: "運動メニュー",
          class: "align-middle p-3 tilte-column",
        },
        {
          key: "category",
          label: "コース",
          class: "align-middle p-3 tilte-column",
        },
        {
          key: "name",
          label: "タイトル",
          class: "align-middle p-3 tilte-column",
        },
        {
          key: "action",
          label: "操作",
          class: "text-center align-middle p-3 tilte-column",
        },
      ];
    },
  },

  methods: {
    async getVideos(page = 1) {
      this.loader = true;
      const res = await api.getVideos(page);
      this.items = res.data.data;
      this.pagination = res.data.meta;
      this.latestPage = res.data.meta.last_page;
      this.page = page;
      this.loader = false;
    },

    showModalEdit(item) {
      this.isFlagShowModalEdit = true;
      this.editingItem = item;
    },

    showVideo(data) {
      if (data.path && data.path != "") {
        this.showVideoFlag = true;
        this.urlVideo = data.path;
      } else {
        window.toastr.error("URLビデオではありません");
        this.urlVideo = null;
      }
    },

    updateItem(updatedItem) {
      let index = this.items.findIndex(i => i.id === this.editingItem.id);
      this.$set(this.items, index, updatedItem);
    },

    async handleDelete(id) {
      Swal.fire({
        title: "",
        text: "削除しますか?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#395299",
        cancelButtonColor: "#FF5858",
        confirmButtonText: "はい",
        cancelButtonText: "いいえ",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await api.destroyVideo(id);
          if (response) {
            window.toastr.success("削除に完了しました");
            await this.getVideos(this.page);
          }
        }
      });
    },

    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<template>
  <div id="admin">
  <Layout class="kurua-page">
    <startVideo :videoURL="urlVideo" @closeModal="showVideoFlag = false" :isShow="showVideoFlag" />
    <div class="col-12 d-flex justify-content-between align-items-center mt-xl-1 mb-xl-2 mt-md-1 mb-md-n4 mt-lg-4 mb-lg-1">
      <div class="col-12 mt-md-n5 mt-xl-0">
        <PageHeader theme="admin" :titleButtonAdd="'動画アップロード'" @showModalAdd="isFlagShowModalAdd = true" :items="breadcrumb" fontSize="28px" fontWeight="700 !important" :showAdd="true" title="動画一覧" />
      </div>
      <!-- <div class="position-absolute mt-lg-n4 mt-md-0 d-flex" style="margin-left: 17rem; margin-top: -2rem;">
        <button @click="reloadPage" class="custom-button">
          <img src="@/assets/images/icon/icon-reload.svg" alt="" style="width: 20px; height: 20px;" />
            更新
        </button>
        <div class="ml-1">
          <p style="margin: 0; padding-right: 10px; font-size: 14px;">最終更新日時:</p>
          <p style="margin: 0; padding-right: 10px; font-size: 14px; margin-top: -5px;">{{ lastLoadedTime }}</p>
        </div>
      </div> -->
    </div>
    <add @close="isFlagShowModalAdd = false" @added="getVideos(page)" :show="isFlagShowModalAdd" />
    <edit @close="(isFlagShowModalEdit = false)" @edited="updateItem" :item="editingItem" :show="isFlagShowModalEdit" />
    <div>
      <div>
        <div class="mb-0" style="min-height: 80vh;">
          <div class="card-body">
            <Loader :loading="loader" theme="plus">
              <div class="col-12">
                <b-table :items="items" :fields="columns" hover outlined thead-class="sticky-top text-center bg-table-lyg" sticky-header style="min-height: 75vh;" responsive="sm">
                  <template #cell(thumbnail)="row">
                    <a href="javascript:void(0)" @click="showVideo(row.item)">
                      <img v-if="row.item.thumbnail" :src="row.item.thumbnail" alt="動画再生" class="avatar-xl h-auto d-block rounded" style="width: 150px;height: auto;" />
                      <img v-else src="@/assets/images/no-data.jpg" alt="" class="avatar-xl h-auto d-block rounded" style="width: 150px;height: auto;"/>
                    </a>
                  </template>
                  <template #cell(type)="row">
                    <span v-html="row.item.type_name.split(',').join('<br>')"></span>
                  </template>
                  <template #cell(category)="row">
                    <span v-html="row.item.category_name.split(',').join('<br>')"></span>
                  </template>
                  <template #cell(name)="row">
                    {{ row.item.name }}
                  </template>
                  <template #cell(action)="row">
                    <ul class="list-inline font-size-20 contact-links mb-0" style="min-width: 100px;">
                      <li title="編集" class="list-inline-item px-2" @click="showModalEdit(row.item)">
                        <a>
                          <img src="@/assets/images/icon/icon-changes.svg" alt="" style="width: 28px; height: 28px; margin-top: -0.5rem; cursor: pointer;" />
                        </a>
                      </li>
                      <li title="削除" @click="handleDelete(row.item.id)" class="list-inline-item px-2">
                        <a href="javascript:void(0)">
                          <i class="bx bx-trash text-white bg-danger p-1" style="border-radius: 50%; cursor: pointer"></i>
                        </a>
                      </li>
                    </ul>
                  </template>
                </b-table>
              </div>
              <Pagination :paging="pagination" @change="getVideos" label="動画数:" unitLabel="件"/>
            </Loader>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  </div>
</template>

<style scoped>
video {
  width: 400px;
  margin: auto;
}

.b-table-sticky-header {
  max-height: 65vh;
}
</style>
